import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReportPage from './ReportPage';
import { getApiUrl } from '../utils/apiBase';

const API = getApiUrl();

const TestReportPage = () => {
  const [testData, setTestData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchTestReport = async () => {
      try {
        const response = await fetch(`${API}/test-report`);

        if (!response.ok) {
          throw new Error('Failed to fetch test report');
        }

        const data = await response.json();

        // Structure the data to match what ReportPage expects
        const structuredData = {
          audit: data.audit_data,
          report: data.report
        };

        setTestData(structuredData);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching test report:', err);
        setError(err.message);
        setLoading(false);
      }
    };

    fetchTestReport();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-slate-600">Generating test report...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex items-center justify-center">
        <div className="text-center max-w-md mx-auto p-6">
          <p className="text-red-600 mb-4">Error: {error}</p>
          <button
            onClick={() => navigate('/audit')}
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            Go to Checkout
          </button>
        </div>
      </div>
    );
  }

  if (!testData) {
    return null;
  }

  // Render the actual ReportPage with test data
  return <ReportPage testMode={true} testData={testData} />;
};

export default TestReportPage;
